import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import Section from "../components/layout/section"
import SEO from "../components/seo"
import LearningCenterSection from "../components/layout/learningcentersection"
import Rocket from '../images/icons/sidebar/web/rocket.svg'
import Contacts from '../images/icons/sidebar/web/contacts.svg'
import CampaignsIcon from '../images/icons/sidebar/web/campaigns.svg'
import BuilderElementsIcon from '../images/icons/sidebar/web/drag-and-drop.svg'

// import { learningCenterDirectory } from "../../data/learningCenterDirectory"

const learningCenterDirectory = [
  {
    icon: Rocket,
    title: 'Getting Started',
    description: 'Quickly get up to speed by learning the basics of using Contacts & Lists, as well as sending your first Campaign.',
    startLink: '/web/getting-started/creating-a-contact'
  },
  {
    icon: Contacts,
    title: 'Contacts & Lists',
    description: 'Learn how to fully use the Contact & Lists area of the system so you can efficiently manage and segment your Contacts.',
    startLink: '/web/contacts-and-lists/previewing-a-contact'
  },
  {
    icon: CampaignsIcon,
    title: 'Campaigns',
    description: 'Learn how to send SMS Campaigns and learn about advanced Campaign filters and features.',
    startLink: '/web/campaigns/sending-an-sms-campaign'
  },
  {
    icon: BuilderElementsIcon,
    title: 'Buider Elements',
    description: 'Learn how to use the builder elements available in Email Campaigns, SMS Campaigns, and Mobile Pages.',
    startLink: '/web/builder-elements/title'
  },
]

class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="All posts"
          keywords={[`blog`, `gatsby`, `javascript`, `react`]}
        />
        <Section>
          <h2>What is MindMe?</h2>
          <p>
          MindMe is a mobile marketing platform that is designed by marketers for people who are looking for an all-in-one tool for growing their businesses. Stop juggling between multiple services providers when you can have a powerful CRM, send SMS and Email marketing campaigns, create and share mobile offers, and create engaging mobile landing pages all in one product.
          </p>
          <p>Use this knowledge base to get help with using the system so you can grow your revenue and start dominating your market today.</p>
        </Section>
        <Section>
          <h2>Learning Center</h2>
          {learningCenterDirectory.map(
            ({ icon, title, description, startLink }) => (
              <LearningCenterSection
                icon={icon}
                title={title}
                description={description}
                startLink={startLink}
              />
            )
          )}
        </Section>
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
          }
        }
      }
    }
  }
`
